import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css";
import WOW from "wowjs";
import "../css/InvestorRelationsPage.css";

const bankerLogos = [
  { src: "/wp-content/uploads/2016/03/state-bank.jpg", title: "State Bank of India" },
  { src: "/wp-content/uploads/2016/03/BOC.jpg", title: "Bank of Ceylon" },
  { src: "/wp-content/uploads/2016/03/commercial-bank.jpg", title: "Commercial Bank" },
  { src: "/wp-content/uploads/2016/03/HNB-bank.jpg", title: "Hatton National Bank" },
  { src: "/wp-content/uploads/2016/03/HSBC-bank.jpg", title: "HSBC" },
  { src: "/wp-content/uploads/2016/03/NDB-bank.jpg", title: "NDB Bank" },
  { src: "/wp-content/uploads/2016/03/peopleBank.jpg", title: "People's Bank" },
  { src: "/wp-content/uploads/2016/03/sampathBank.jpg", title: "Sampath Bank" }
];

const InvestorRelationsPage = () => {
  useEffect(() => {
    new WOW.WOW({
      live: false,
      animateClass: 'animate__animated',
    }).init();
  }, []);
  const [isMobile, setIsMobile] = useState(false);
const [mobileBankerIndex, setMobileBankerIndex] = useState(0);

useEffect(() => {
  const checkMobile = () => setIsMobile(window.innerWidth <= 768);
  checkMobile();

  window.addEventListener("resize", checkMobile);
  return () => window.removeEventListener("resize", checkMobile);
}, []);

const nextBanker = () => {
  setMobileBankerIndex((prev) => (prev + 1) % bankerLogos.length);
};

const prevBanker = () => {
  setMobileBankerIndex((prev) =>
    prev === 0 ? bankerLogos.length - 1 : prev - 1
  );
};

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: true,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 0,
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        centerMode: false,
        variableWidth: false
      }
    }
  ]
};

  return (
    <>
      <Header />

      {/* Banner Section */}
      <section
        className="relative w-full"
        style={{
          height: '400px',
          backgroundImage: "url('/wp-content/uploads/2016/02/investor_relations-.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
      </section>

      {/* Main Content */}
      <section className="contentwrapper clearfix contact-page">
        <div className="content clearfix">

          {/* Breadcrumbs */}
          <div className="contact-breadcrumb breadcrumbs">
            <a href="/">Home</a> &gt; <span>Investor Relations</span>
          </div>

          <h1 data-aos="fade-right"><strong className="investor-page-title">INVESTOR RELATIONS</strong></h1>

          {/* Row 1 */}
          <div className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle investor-relation-box clearfix">

            <div className="vc_col-sm-3" style={{ backgroundColor: '#2e72a2' }} data-aos="fade-up" data-aos-delay="100">
              <div className="ir-padding-10">
                <div>
                  <h2><strong>Name of Company</strong></h2>
                  <p>&nbsp;</p>
                  <p>Colombo Dockyard PLC</p>
                </div>
              </div>
            </div>

            <div className="vc_col-sm-3" style={{ backgroundImage: "url('/wp-content/uploads/2016/02/court_647_091515084250_091915105719_101615075414-1.jpg@id=1886')", backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} data-aos="fade-up" data-aos-delay="200">
              <div className="ir-padding-10 ir-dark-overlay">
                <div>
                  <h2><strong>Legal Form</strong></h2>
                  <p>&nbsp;</p>
                  <p>A Public Quoted Company with Limited Liability. Incorporated and domiciled in Sri Lanka</p>
                </div>
              </div>
            </div>

            <div className="vc_col-sm-3" style={{ backgroundColor: '#2e72a2' }} data-aos="fade-up" data-aos-delay="300">
              <div className="ir-padding-10">
                <div>
                  <h2><strong>Company Registration Number</strong></h2>
                  <p>&nbsp;</p>
                  <p>PQ 50, Founded in 1974</p>
                </div>
              </div>
            </div>

            <div className="vc_col-sm-3" style={{ backgroundColor: '#002049' }} data-aos="fade-up" data-aos-delay="400">
              <div className="ir-padding-10">
                <div>
                  <h2><strong>BOI Registration Number</strong></h2>
                  <p>&nbsp;</p>
                  <p>A Licensed Enterprise under section 17 of the Board of Investment of Sri Lanka (formerly GCEC) Law No.4 of 1978</p>
                  <p>Registration No. 91/17/03/1983</p>
                </div>
              </div>
            </div>

          </div>
          <div className="vc_row-full-width vc_clearfix"></div>

          {/* Row 2 */}
          <div className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle investor-relation-box clearfix">

            <div className="vc_col-sm-6" style={{ backgroundColor: '#002049' }} data-aos="fade-right">
              <div className="ir-padding-2">
                <div>
                  <h2 style={{ textAlign: 'center' }}><strong>Tax Registration Numbers</strong></h2>
                  <p>&nbsp;</p>
                  <div className="tax-number-box">
  <div>
    <strong>VAT</strong>
    <span>124085896-7000</span>
  </div>
  <div>
    <strong>Income tax</strong>
    <span>124085896-0000</span>
  </div>
  <div>
    <strong>ESC</strong>
    <span>124085896-8000</span>
  </div>
  <div>
    <strong>NBT</strong>
    <span>124085896-9000</span>
  </div>
</div>
                </div>
              </div>
            </div>

            <div className="vc_col-sm-3" style={{ backgroundImage: "url('/wp-content/uploads/2016/02/aca-slika-4.jpg@id=1887')", backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} data-aos="fade-up" data-aos-delay="100">
              <div className="ir-padding-10 ir-dark-overlay">
                <div>
                  <h2><strong>Accounting Year End</strong></h2>
                  <p>&nbsp;</p>
                  <p>31st December</p>
                </div>
              </div>
            </div>

            <div className="vc_col-sm-3" style={{ backgroundColor: '#2e72a2' }} data-aos="fade-left">
              <div className="ir-padding-10">
                <div>
                  <h2><strong>Registrars</strong></h2>
                  <p>&nbsp;</p>
                  <p><strong>P &amp; W Corporate Secretarial (Pvt) Ltd</strong><br />
                    3/17, Kynsey Road,<br />
                    Colombo 8.</p>
                </div>
              </div>
            </div>

          </div>
          <div className="vc_row-full-width vc_clearfix"></div>

          {/* Row 3 */}
          <div className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle investor-relation-box clearfix">

            <div className="vc_col-sm-6" style={{ backgroundColor: '#2e72a2' }} data-aos="fade-right">
              <div className="ir-padding-custom-1">
                <div>
                  <h2><strong>Directors</strong></h2>
                  <p>&nbsp;</p>
                  <p><strong>Lalith Ganlath</strong></p>
                  <p><strong>Sarath De Costa</strong></p>
                  <p><strong>Thimira S. Godakumbura</strong></p>
                  <p><strong>V.G.L.A. Jayawardena</strong></p>
                  <p><strong>Nihal D. Liyanage</strong></p>
                  <p><strong>Chathura Chanaka Wickramathileka</strong></p>
                  <p><strong>Chanaka A. M. Jayamaha</strong></p>
                </div>
              </div>
            </div>

            <div className="vc_col-sm-6" style={{ backgroundImage: "url('/wp-content/uploads/2016/02/MV-CORALS-2-1.jpg@id=1908')", backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} data-aos="fade-left">
              <div className="ir-padding-custom-2 ir-dark-overlay">
                <div>
                  <h2><strong>General Management</strong></h2>
                  <p><strong>Thimira S. Godakumbura</strong> (Managing Director / CEO)</p>
                  <p><strong>Prabath Abeysinghe</strong> (General Manager – Yard Development)</p>
                  <p><strong>N.M.K.B. Nayakarathna</strong> (Managing Director / CEO – DGES)</p>
                  <p><strong>K.B.P. Fernando</strong> (Chief Commercial Officer)</p>
                  <p><strong>Mangala De Silva</strong> (General Manager – Human Resource Development &amp; Administration)</p>
                  <p><strong>S.D. Gilbert</strong> (General Manager – DGES)</p>
                  <p><strong>R.M. Vajira Rathnayaka</strong> (General Manager – Supply Chain Management)</p>
                  <p><strong>P.D. Gihan Ravinatha</strong> (General Manager (Finance) / CFO)</p>
                  <p><strong>Manori Mallikarachchi</strong> (Legal Consultant / Company Secretary)</p>
                  <p><strong>S.G. Senadeera</strong> (General Manager – Ship Repair Business)</p>
                  <p><strong>K. N. G. W. Kariyawasam</strong> (General Manager (Production))</p>
                </div>
              </div>
            </div>

          </div>
          <div className="vc_row-full-width vc_clearfix"></div>

          {/* Row 4 */}
          <div className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle investor-relation-box clearfix">

            <div className="vc_col-sm-6" style={{ backgroundColor: '#002049' }} data-aos="fade-right">
              <div className="ir-padding-custom-1">
                <div>
                  <h2><strong>Company Secretary</strong></h2>
                  <p>&nbsp;</p>
                  <p><strong>Ms. Manori P. Mallikarachchi</strong></p>
                  <p>Telephone: <a href="tel:+9411249000" style={{ color: '#fff' }}>+94 11249000</a></p>
                  <p>Fax : <a href="fax:+94112446441" style={{ color: '#fff' }}>+94 11 2446441</a></p>
                  <p>E mail: <a href="mailto:manori@cdl.lk" style={{ color: '#fff' }}>manori@cdl.lk</a></p>
                  <p>Graving Docks, Port of Colombo,<br />
                    Colombo 15, Sri Lanka</p>
                </div>
              </div>
            </div>

            <div className="vc_col-sm-6" style={{ backgroundColor: '#2e72a2' }} data-aos="fade-left">
              <div className="ir-padding-custom-2">
                <div>
                  <h2><strong>Auditors</strong></h2>
                  <p>&nbsp;</p>
                  <p><strong>KPMG Ford, Rhodes,<br />
                    Thornton &amp; Co</strong><br />
                    Chartered Accountants<br />
                    32A, Sir Mohamed Macan Markar Mawatha,<br />
                    Colombo 3,<br />
                    Sri Lanka.</p>
                </div>
              </div>
            </div>

          </div>
          <div className="vc_row-full-width vc_clearfix"></div>

          {/* Subsidiary Banner */}
          <div className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle investor-relation-box clearfix">
            <div className="vc_col-sm-12" style={{ backgroundColor: '#000000', width: '100%' }}>
              <div className="ir-padding-banner">
                <div data-aos="fade-right">
                  <h2 style={{ textAlign: 'center' }}><strong>SUBSIDIARY COMPANIES</strong></h2>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row-full-width vc_clearfix"></div>

          {/* Subsidiary Content */}
          <div className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle investor-relation-box clearfix">
            <div className="vc_col-sm-6" style={{ backgroundColor: '#2e72a2' }} data-aos="fade-right">
              <div className="ir-padding-10">
                <div>
                  <p><strong>Dockyard General Engineering Services (Pvt) Ltd</strong><br />
                    223, Jayantha Mallimarachchi Mawatha,<br />
                    Colombo 14,<br />
                    Sri Lanka.</p>
                </div>
              </div>
            </div>

            <div className="vc_col-sm-6" style={{ backgroundColor: '#002049' }} data-aos="fade-left">
              <div className="ir-padding-10">
                <div>
                  <p><strong>Ceylon Shipping Agency (Pte) Ltd</strong><br />
                    35, Selegie Rd,<br />
                    09-16 Parklane Shopping Mall,<br />
                    Singapore – 188307.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row-full-width vc_clearfix"></div>

          {/* Bankers Banner */}
          <div className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle investor-relation-box clearfix">
            <div className="vc_col-sm-12" style={{ backgroundColor: '#000000', width: '100%' }}>
              <div className="ir-padding-banner">
                <div data-aos="fade-right">
                  <h2 style={{ textAlign: 'center' }}><strong>BANKERS</strong></h2>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row-full-width vc_clearfix"></div>

          {/* Bankers Slider */}
          <div className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle investor-relation-box clearfix">
            <div className="vc_col-sm-12" style={{ backgroundColor: '#2e72a2', width: '100%' }} data-aos="fade-up">
              <div className="ir-padding-custom-1" style={{ padding: '5% 8% !important' }}>
                <div>
                  {isMobile ? (
  <div className="mobile-banker-slider">
    <button type="button" className="mobile-banker-arrow left" onClick={prevBanker}>
      ‹
    </button>

    <div className="mobile-banker-logo">
      <img
        src={bankerLogos[mobileBankerIndex].src}
        alt={bankerLogos[mobileBankerIndex].title}
      />
    </div>

    <button type="button" className="mobile-banker-arrow right" onClick={nextBanker}>
      ›
    </button>
  </div>
) : (
  <Slider {...sliderSettings} className="banker-slider">
    {bankerLogos.map((logo, idx) => (
      <div key={idx} className="slider-item">
        <div className="logo-box">
          <img src={logo.src} alt={logo.title} title={logo.title} />
        </div>
      </div>
    ))}
  </Slider>
)}
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row-full-width vc_clearfix"></div>

        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default InvestorRelationsPage;
